import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import rootReducer from "store/reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ['authReducer']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let cachedInstance = null;

const storeConfig = () => {
  if (cachedInstance) return cachedInstance;

  const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(thunk))
  );

  const persistor = persistStore(store);

  cachedInstance = { store, persistor };
  return cachedInstance;
};

export default storeConfig;